exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.trip-itinerary-item .v-textarea textarea {\n    border: none;\n    height: auto;\n    margin-bottom: 0;\n    padding: 0;\n}\n", ""]);

// exports
